import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  ValidatorFn,
  AbstractControl,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ApiServiceService } from "src/app/Services/api-service.service";
import { AuthService } from "src/app/Services/auth.service";
import * as alertify from "alertifyjs";
import { ConfirmDialogComponent } from "src/app/Shared/shared/confirm-dialog/confirm-dialog.component";
import { ErrorDialogComponent } from "src/app/Shared/shared/error-dialog/error-dialog.component";
import { SuccessDialogComponent } from "src/app/Shared/shared/success-dialog/success-dialog.component";

@Component({
  selector: "app-edit-user-personai-information",
  templateUrl: "./edit-user-personai-information.component.html",
  styleUrls: ["./edit-user-personai-information.component.css"],
})
export class EditUserPersonaiInformationComponent {
  @Output() onConfirmClicked = new EventEmitter();
  @Input() userDetail: any;
  isLoading: boolean = false;
  isEmpty: boolean;

  editNonCompanyForm: FormGroup;
  editCompanyForm: FormGroup;
  userDetails: any;
  companyDetails: any;
  lgaList: any;
  occupationList: any;
  businessClassificationList: any[] = [];
  natureOfBusinessList: any[] = [];

  constructor(
    private apiService: ApiServiceService,
    private bsModalService: BsModalService,
    public fb: FormBuilder,
    private bsModalRef: BsModalRef
  ) {
    this.editNonCompanyForm = this.fb.group({
      userId: [""],
      phoneNumber: [
        "",
        [Validators.required, this.phoneNumberValidator.bind(this)],
      ],
      email: ["", [Validators.required, this.emailValidator()]],
      address: ["", Validators.required],
      lgaId: [""],
      lgaName: [""],
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      gender: [""],
      occupationId: [""],
      dob: [""],
      maritalStatus: [""],
      nin: [""],
      tin: ["", Validators.required],
    });

    this.editCompanyForm = this.fb.group({
      userId: [""],
      // phoneNumber: [
      //   "",
      //   [Validators.required, this.phoneNumberValidator.bind(this)],
      // ],
      // email: ["", [Validators.required, this.emailValidator()]],
      phoneNumber: [""],
      email: [""],
      address: ["", Validators.required],
      lgaId: [""],
      lgaName: [""],
      corporateName: ["", Validators.required],
      classification: [""],
      natureOfBusiness: [""], //natureOfBusiness
      rcNumber: [""],
      tin: ["", Validators.required],
    });
  }

  ngOnInit(): void {
    this.getAllLga();
    this.getAllOccupation();
    this.getAllBusinessClassifications();
    this.getAllNatureOfBusinessList();
    this.getUserDetails();
  }

  getAllBusinessClassifications() {
    this.apiService.get("/assessments/business_categories").subscribe(
      (reponse) => {
        this.businessClassificationList = reponse;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getAllNatureOfBusinessList() {
    this.apiService.LoginGet("/auth/utility/business_nature/all").subscribe(
      (reponse) => {
        this.natureOfBusinessList = reponse;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getAllLga() {
    this.apiService.LoginGet("/auth/lga/all").subscribe(
      (reponse) => {
        this.lgaList = reponse;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getAllOccupation() {
    this.apiService.LoginGet("/auth/occupation/all").subscribe(
      (reponse) => {
        this.occupationList = reponse;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  emailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      // Regular expression for a strict email format validation
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

      if (control.value && !emailPattern.test(control.value)) {
        return { invalidEmail: true };
      }

      return null;
    };
  }

  phoneNumberValidator(control: any) {
    const phoneNumber = control.value;
    if (!phoneNumber) {
      return { required: true }; // Required validation error
    }

    const cleanedPhoneNumber = phoneNumber.replace(/\s/g, "").replace(/-/g, "");
    const isDigitsOnly = /^\d+$/.test(cleanedPhoneNumber);

    if (
      (cleanedPhoneNumber.length === 11 && isDigitsOnly) ||
      (cleanedPhoneNumber.length === 13 &&
        cleanedPhoneNumber.startsWith("234")) ||
      (cleanedPhoneNumber.length === 14 &&
        cleanedPhoneNumber.startsWith("+234"))
    ) {
      return null; // Valid phone number
    } else {
      return { invalidPhoneNumber: true }; // Invalid phone number format
    }
  }

  getUserDetails() {
    let request = {
      userId: this.userDetail?.userId,
      taxGroup: this.userDetail?.taxgroup,
    };

    const url = "/auth/user/details";

    if (
      this.userDetail?.taxgroup != "COMPANY" &&
      this.userDetail?.taxgroup != "INFORMAL"
    ) {
      this.apiService.loginPost_(url, request).subscribe(
        (response) => {
          this.userDetails = response;

          this.editNonCompanyForm.patchValue({
            firstName: this.userDetails?.firstName || "",
            phoneNumber: this.userDetails?.phoneNumber || "",
            email: this.userDetails?.email || "",
            address: this.userDetails?.address || "",
            lastName: this.userDetails?.lastName || "",
            nin: this.userDetails?.nin || "",
            tin: this.userDetails?.tin || "",
            dob: this.userDetails?.dob || "",
          });

          this.isLoading = false;
        },
        (error) => {
          alertify.set("notifier", "position", "top-center");
          alertify.error("Error performing this operation");
          this.isLoading = false;
        }
      );
    } else {
      this.apiService.loginPost_(url, request).subscribe(
        (response) => {
          this.companyDetails = response;

          this.editCompanyForm.patchValue({
            corporateName: this.companyDetails?.displayName || "",
            phoneNumber: this.companyDetails?.phoneNumber || "",
            email: this.companyDetails?.email || "",
            rcNumber: this.companyDetails?.rcNumber || "",
            tin: this.companyDetails?.tin || "",
            address: this.companyDetails?.address || "",
          });

          this.isLoading = false;
        },
        (error) => {
          alertify.set("notifier", "position", "top-center");
          alertify.error("Error performing this operation");
          this.isLoading = false;
        }
      );
    }
  }

  confirmEdit() {
    let dfModalRef = this.bsModalService.show(ConfirmDialogComponent, {
      initialState: {
        body: "Proceed to save changes",
      },
      class: "modal-sm modal-dialog-centered",
    });
    dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
      this.saveNonCompanyEdits();
      dfModalRef.hide();
    });
  }

  confirmCompanyEdit() {
    let dfModalRef = this.bsModalService.show(ConfirmDialogComponent, {
      initialState: {
        body: "Proceed to save changes",
      },
      class: "modal-sm modal-dialog-centered",
    });
    dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
      this.saveCompanyEdits();
      dfModalRef.hide();
    });
  }

  saveCompanyEdits() {
    this.isLoading = true;

    let pojo = this.editCompanyForm.value;

    pojo["userId"] = this.userDetail?.userId;

    const url = "/auth/edit-user-details";

    this.apiService.loginPost_(url, pojo).subscribe(
      (response) => {
        this.isLoading = false;

        if (response.status == "OK") {
          this.confirmAfterSuccess(response.message);
          alertify.set("notifier", "position", "top-center");
          alertify.success("Account has been successfully updated");
        } else {
          this.confirmAfterError("Action was not successful");
          alertify.set("notifier", "position", "top-center");
          alertify.error("Error performing this operation");
        }
      },
      (error) => {
        this.confirmAfterError("Action was not successful");
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
        this.isLoading = false;
      }
    );
  }

  saveNonCompanyEdits() {
    this.isLoading = true;

    let pojo = this.editNonCompanyForm.value;

    pojo["userId"] = this.userDetail?.userId;

    const url = "/auth/edit-user-details";

    this.apiService.loginPost_(url, pojo).subscribe(
      (response) => {
        this.isLoading = false;

        if (response.status == "OK") {
          this.confirmAfterSuccess(response.message);
          alertify.set("notifier", "position", "top-center");
          alertify.success("Account has been successfully updated");
        } else {
          this.confirmAfterError("Action was not successful");
          alertify.set("notifier", "position", "top-center");
          alertify.error("Error performing this operation");
        }
      },
      (error) => {
        this.confirmAfterError("Action was not successful");
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
        this.isLoading = false;
      }
    );
  }

  confirmAfterSuccess(message: any) {
    let dfModalRef = this.bsModalService.show(SuccessDialogComponent, {
      initialState: {
        body: message,
      },
      class: "modal-sm modal-dialog-centered",
    });
    dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
      dfModalRef.hide();
    });
  }

  confirmAfterError(message: any) {
    let dfModalRef = this.bsModalService.show(ErrorDialogComponent, {
      initialState: {
        body: message,
      },
      class: "modal-sm modal-dialog-centered",
    });
    dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
      dfModalRef.hide();
    });
  }

  close() {
    this.onConfirmClicked.emit();
    this.bsModalRef.hide();
  }
}
